import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'demo',
    component: () => import('@/views/pages/demoPage.vue'),
    meta: {
      layout: 'empty-layout',
    },
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
